import { AUDIT_MODELS_API_URL, AUDIT_MODELS_FIELDS_URL, LATEST_AUDIT_MODELS_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';
import { COPY_SUFFIX_TRANSLATION_KEY } from '../constants';

export const applicationReadySuccess = (id, language) => ({
  type: types.APPLICATION_IS_READY_SUCCESS,
  payload: { id, language },
});

export const applicationReadyFailure = message => ({
  type: types.APPLICATION_IS_READY_FAILURE,
  payload: { message },
  error: true,
});

export const fetchRequest = auditModelId => ({
  type: types.FETCH,
  payload: {
    request: {
      method: 'GET',
      url: `${LATEST_AUDIT_MODELS_API_URL}/search/findByAuditModelId`,
      params: {
        auditModelId,
      },
    },
  },
});

export const fetchSuccess = auditModel => ({
  type: types.FETCH_SUCCESS,
  payload: { auditModel },
});

export const fetchFailure = (message, meta = {}) => ({
  type: types.FETCH_FAILURE,
  payload: { message },
  error: true,
  meta: {
    redirectError: true,
    ...meta,
  },
});

export const fetchFields = () => ({
  type: types.FETCH_FIELDS,
  payload: {
    request: {
      url: AUDIT_MODELS_FIELDS_URL,
      method: 'GET',
    },
  },
});

export const fetchFieldsSuccess = fields => ({
  type: types.FETCH_FIELDS_SUCCESS,
  payload: { fields },
});

export const fetchFieldsFailure = message => ({
  type: types.FETCH_FIELDS_FAILURE,
  payload: { message },
  error: true,
});

// TODO - Once intlReducer has been reworked, use intl, for now it erases all translations, it must merge
export const fetchTranslations = langs => ({
  type: types.FETCH_TRANSLATIONS,
  payload: {
    request: {
      // TODO - Add url + method once you remove intlService in saga
      params: {
        langs,
        keys: [
          COPY_SUFFIX_TRANSLATION_KEY,
          'audito.model.builder.sections.section.identification',
          'audito.model.builder.sections.section.question.referenceQuestion',
          'audito.model.builder.sections.section.question.authorQuestion',
          'audito.model.builder.sections.section.question.employeeQuestion',
        ].join(),
      },
    },
  },
});

export const fetchTranslationsSuccess = translations => ({
  type: types.FETCH_TRANSLATIONS_SUCCESS,
  payload: translations,
});

export const fetchTranslationsFailure = message => ({
  type: types.FETCH_TRANSLATIONS_FAILURE,
  payload: { message },
  error: true,
});

export const create = auditModel => ({
  type: types.CREATE,
  payload: {
    request: {
      method: 'POST',
      url: AUDIT_MODELS_API_URL,
      data: auditModel,
    },
  },
});

export const createSuccess = auditModel => ({
  type: types.CREATE_SUCCESS,
  payload: { auditModel },
});

export const createFailure = message => ({
  type: types.CREATE_FAILURE,
  payload: { message },
  error: true,
});

export const update = auditModel => ({
  type: types.UPDATE,
  payload: {
    request: {
      method: 'PUT',
      url: `${AUDIT_MODELS_API_URL}/${auditModel.id}`,
      data: auditModel,
    },
  },
});

export const updateSuccess = auditModel => ({
  type: types.UPDATE_SUCCESS,
  payload: { auditModel },
});

export const updateFailure = message => ({
  type: types.UPDATE_FAILURE,
  payload: { message },
  error: true,
});

export const setSelectedLanguage = language => ({
  type: types.SET_SELECTED_LANGUAGE,
  payload: { language },
});
